import { createIcon } from '../createIcon.tsx';

export const ChevronUpIcon = createIcon('ChevronUpIcon', <polyline points="18 15 12 9 6 15" />);
